export const PREVIEW_HEIGHT = 812
export const PREVIEW_BORDER_SIZE = 12
export const PREVIEW_WIDTH = 375

/** Height and width of FP phone frame preview before the refreshed FP editor */
export const LEGACY_PREVIEW_HEIGHT = 575
export const LEGACY_PREVIEW_WIDTH = 280

export const PREVIEW_SECTION_PADDING = 24
